import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAddPlanzoneResourceToProjectNotificationState = createStateReducer(
  initialState,
  {
    [events.addPlanzoneResourceToProjectSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addPlanzoneResourceToProject",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.addPlanzoneResourceToProjectFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addPlanzoneResourceToProject",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAddPlanzoneResourceToProjectNotificationState };
